// extracted by mini-css-extract-plugin
export default {"masterShoot":"masterShoot_masterShoot__RG4cq"};